export default __webpack_public_path__ + "static/media/hotBackground.d544f9da.png";